import marketplace from "@/services/marketplace";
import notification from "@/services/notification";

export default {
  namespaced: true,
  state: {
    loading: false,
    errors: null,
    quicksight_url: null
  },
  getters: {
    loading: state => state.loading,
    quicksight_url: state => state.quicksight_url
  },
  mutations: {
    SET_LOADING(state, value) {
      state.loading = value;
    },
    SET_ERRORS(state, errors) {
      state.errors = errors;
    },
    SET_QUICKSIGHT_URL(state, url) {
      state.quicksight_url = url;
    }
  },
  actions: {
    async getQuicksightURL({ commit }, merchant_uuid) {
      commit("SET_LOADING", true);
      try {
        const response = await marketplace.getQuicksightURL(merchant_uuid);
        commit("SET_QUICKSIGHT_URL", response.redirect_url);
      } catch (errors) {
        commit("SET_ERRORS", errors);
      } finally {
        commit("SET_LOADING", false);
      }
    }
  }
}
